<template>
<div class="flow-path">
  <div class="flow-path-item" v-for="(node_list,node_list_index) in flow_path" :key="node_list_index">
    <el-steps align-center>
      <el-step v-for="(node,node_index) in node_list" :key="node_index" :title="node.type"></el-step>
    </el-steps>
  </div>
</div>
</template>

<script>
export default {
  name: "FlowPathPanel",
  props:{
    flow_path:{
      type:Array,
      default() {
        return [];
      }
    }
  },
  data(){
    return{

    }
  },
  methods:{

  }
}
</script>

<style lang="scss" scoped>
.flow-path{

}
.flow-path-item{
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/LFComponents/FlowPathPanel.vue